import { Fragment } from "react";
import { MARQUEE } from "@/lib/site";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((m) => (
      <Fragment key={m}>
        <span className="font-display text-3xl sm:text-5xl font-semibold tracking-tight text-[var(--navy)] px-6 sm:px-10 whitespace-nowrap">{m}</span>
        <span className="h-2.5 w-2.5 rounded-full bg-[var(--green)] shrink-0" />
      </Fragment>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="border-y border-slate-200 bg-white py-8 sm:py-10 overflow-hidden" data-testid="services-marquee" aria-label="Services we offer">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
